/* eslint-disable import/no-cycle */
/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';
// changeSpa

/* AUTH */
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const CHANGE_SPA = 'CHANGE_SPA';
export const CHANGE_USER_IMAGE = 'CHANGE_USER_IMAGE';
export const CHANGE_USER_USERNAME = 'CHANGE_USER_USERNAME';
export const CHANGE_SPA_DETAIL_BY_COMPANY_DETAIL = "CHANGE_SPA_DETAIL_BY_COMPANY_DETAIL";
export const LOAD_NOTIFY = "LOAD_NOTIFY";
export const LOAD_NOTIFY_SUCCESS = "LOAD_NOTIFY_SUCCESS";

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS =
  'MENU_CHANGE_HAS_SUB_ITEM_STATUS';

/* TODOAPP */
export const TODO_GET_LIST = 'TODO_GET_LIST';
export const TODO_GET_LIST_SUCCESS = 'TODO_GET_LIST_SUCCESS';
export const TODO_GET_LIST_ERROR = 'TODO_GET_LIST_ERROR';
export const TODO_GET_LIST_WITH_FILTER = 'TODO_GET_LIST_WITH_FILTER';
export const TODO_GET_LIST_WITH_ORDER = 'TODO_GET_LIST_WITH_ORDER';
export const TODO_GET_LIST_SEARCH = 'TODO_GET_LIST_SEARCH';
export const TODO_ADD_ITEM = 'TODO_ADD_ITEM';
export const TODO_ADD_ITEM_SUCCESS = 'TODO_ADD_ITEM_SUCCESS';
export const TODO_ADD_ITEM_ERROR = 'TODO_ADD_ITEM_ERROR';
export const TODO_SELECTED_ITEMS_CHANGE = 'TODO_SELECTED_ITEMS_CHANGE';

/* CHAT APP */
export const CHAT_GET_CONTACTS = 'CHAT_GET_CONTACTS';
export const CHAT_GET_CONTACTS_SUCCESS = 'CHAT_GET_CONTACTS_SUCCESS';
export const CHAT_GET_CONTACTS_ERROR = 'CHAT_GET_CONTACTS_ERROR';
export const CHAT_GET_CONVERSATIONS = 'CHAT_GET_CONVERSATIONS';
export const CHAT_GET_CONVERSATIONS_SUCCESS = 'CHAT_GET_CONVERSATIONS_SUCCESS';
export const CHAT_GET_CONVERSATIONS_ERROR = 'CHAT_GET_CONVERSATIONS_ERROR';
export const CHAT_ADD_MESSAGE_TO_CONVERSATION =
  'CHAT_ADD_MESSAGE_TO_CONVERSATION';
export const CHAT_CREATE_CONVERSATION = 'CHAT_CREATE_CONVERSATION';
export const CHAT_SEARCH_CONTACT = 'CHAT_SEARCH_CONTACT';
export const CHAT_CHANGE_CONVERSATION = 'CHAT_CHANGE_CONVERSATION';

/* SURVEY LIST APP */
export const SURVEY_LIST_GET_LIST = 'SURVEY_LIST_GET_LIST';
export const SURVEY_LIST_GET_LIST_SUCCESS = 'SURVEY_LIST_GET_LIST_SUCCESS';
export const SURVEY_LIST_GET_LIST_ERROR = 'SURVEY_LIST_GET_LIST_ERROR';
export const SURVEY_LIST_GET_LIST_WITH_FILTER =
  'SURVEY_LIST_GET_LIST_WITH_FILTER';
export const SURVEY_LIST_GET_LIST_WITH_ORDER =
  'SURVEY_LIST_GET_LIST_WITH_ORDER';
export const SURVEY_LIST_GET_LIST_SEARCH = 'SURVEY_LIST_GET_LIST_SEARCH';
export const SURVEY_LIST_ADD_ITEM = 'SURVEY_LIST_ADD_ITEM';
export const SURVEY_LIST_ADD_ITEM_SUCCESS = 'SURVEY_LIST_ADD_ITEM_SUCCESS';
export const SURVEY_LIST_ADD_ITEM_ERROR = 'SURVEY_LIST_ADD_ITEM_ERROR';
export const SURVEY_LIST_SELECTED_ITEMS_CHANGE =
  'SURVEY_LIST_SELECTED_ITEMS_CHANGE';

/* SURVEY DETAIL APP */
export const SURVEY_GET_DETAILS = 'SURVEY_GET_DETAILS';
export const SURVEY_GET_DETAILS_SUCCESS = 'SURVEY_GET_DETAILS_SUCCESS';
export const SURVEY_GET_DETAILS_ERROR = 'SURVEY_GET_DETAILS_ERROR';
export const SURVEY_DELETE_QUESTION = 'SURVEY_DELETE_QUESTION';
export const SURVEY_SAVE = 'SURVEY_SAVE';

// -------------select ADDRESS ----------------//
export const LOAD_COUNTRY = "LOAD_COUNTRY";
export const LOAD_COUNTRY_SUCCESS = "LOAD_COUNTRY_SUCCESS";
export const ADDRESS_LOAD_PROVICE = "ADDRESS_LOAD_PROVICE";
export const ADDRESS_LOAD_PROVICE_SUCCESS = "ADDRESS_LOAD_PROVICE_SUCCESS";
export const ADDRESS_LOAD_DISTRICT = "ADDRESS_LOAD_DISTRICT";
export const ADDRESS_LOAD_DISTRICT_SUCCESS = "ADDRESS_LOAD_DISTRICT_SUCCESS";
export const ADDRESS_LOAD_SUB_DISTRICT = "ADDRESS_LOAD_SUB_DISTRICT";
export const ADDRESS_LOAD_SUB_DISTRICT_SUCCESS = "ADDRESS_LOAD_SUB_DISTRICT_SUCCESS";
export const ADDRESS_LOAD_DISTRICT2 = "ADDRESS_LOAD_DISTRICT2";
export const ADDRESS_LOAD_DISTRICT_SUCCESS2 = "ADDRESS_LOAD_DISTRICT_SUCCESS2";
export const ADDRESS_LOAD_SUB_DISTRICT2 = "ADDRESS_LOAD_SUB_DISTRICT2";
export const ADDRESS_LOAD_SUB_DISTRICT_SUCCESS2 = "ADDRESS_LOAD_SUB_DISTRICT_SUCCESS2";


export const GET_DATA_FROM_TOKEN = 'GET_DATA_FROM_TOKEN';
/* USER */
export const SETTING_ERROR_MESSAGE = "SETTING_ERROR_MESSAGE";
export const CLOSE_SETTING_ERROR_MESSAGE = "CLOSE_SETTING_ERROR_MESSAGE";
export const USER_MANAGEMENT_LOAD_ALL_DATA = "USER_MANAGEMENT_LOAD_ALL_DATA";
export const USER_MANAGEMENT_LOAD_ALL_DATA_SUCCESS = "USER_MANAGEMENT_LOAD_ALL_DATA_SUCCESS";
export const USER_MANAGEMENT_ADD_NAME_ROLECATEGORY = 'USER_MANAGEMENT_ADD_NAME_ROLECATEGORY';
export const USER_MANAGEMENT_ADD_NAME_ROLECATEGORY_SUCCESS = "USER_MANAGEMENT_ADD_NAME_ROLECATEGORY_SUCCESS";
export const USER_MANAGEMENT_UPDATE_NAME_ROLECATEGORY = 'USER_MANAGEMENT_UPDATE_NAME_ROLECATEGORY';
export const USER_MANAGEMENT_UPDATE_NAME_ROLECATEGORY_SUCCESS = "USER_MANAGEMENT_UPDATE_NAME_ROLECATEGORY_SUCCESS";
export const USER_MANAGEMENT_LOAD_NATIONALITY = "USER_MANAGEMENT_LOAD_NATIONALITY"
// Nationality NATIONALITY
export const USER_MANAGEMENT_LOAD_NATIONALITY_SUCCESS = "USER_MANAGEMENT_LOAD_NATIONALITY_SUCCESS";
export const USER_MANAGEMENT_LOAD_ROLECATEGORY = "USER_MANAGEMENT_LOAD_ROLECATEGORY"
export const USER_MANAGEMENT_LOAD_ROLECATEGORY_SUCCESS = "USER_MANAGEMENT_LOAD_ROLECATEGORY_SUCCESS";
export const USER_MANAGEMENT_DELETE_ROLECATEGORY = "USER_MANAGEMENT_DELETE_ROLECATEGORY"
export const USER_MANAGEMENT_DELETE_ROLECATEGORY_SUCCESS = "USER_MANAGEMENT_DELETE_ROLECATEGORY_SUCCESS";


export const USER_MANAGEMENT_CREATE_USER_PASS = "USER_MANAGEMENT_CREATE_USER_PASS"
export const USER_MANAGEMENT_CREATE_USER_PASS_SUCCESS = "USER_MANAGEMENT_CREATE_USER_PASS_SUCCESS";
export const USER_MANAGEMENT_RESET_USER_PASS = "USER_MANAGEMENT_RESET_USER_PASS";
export const USER_MANAGEMENT_RESET_USER_PASS_SUCCESS = "USER_MANAGEMENT_RESET_USER_PASS_SUCCESS";


export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const LOAD_USER = 'LOAD_USER';
export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const USER_MANAGEMENT_UPDATE_USER = 'USER_MANAGEMENT_UPDATE_USER';
export const USER_MANAGEMENT_UPDATE_USER_SUCCESS = 'USER_MANAGEMENT_UPDATE_USER_SUCCESS';

// /* ------------------ROLE MANAGEMENT------------------- */
export const ROLE_MANAGEMENT_LOAD_ALL_DATA = "ROLE_MANAGEMENT_LOAD_ALL_DATA";
export const ROLE_MANAGEMENT_LOAD_ALL_DATA_SUCCESS = "ROLE_MANAGEMENT_LOAD_ALL_DATA_SUCCESS";
export const ROLE_MANAGEMENT_CREATE_ROLE = "ROLE_MANAGEMENT_CREATE_ROLE";
export const ROLE_MANAGEMENT_CREATE_ROLE_SUCCESS = "ROLE_MANAGEMENT_CREATE_ROLE_SUCCESS";
export const ROLE_MANAGEMENT_UPDATE_ROLE = "ROLE_MANAGEMENT_UPDATE_ROLE";
export const ROLE_MANAGEMENT_UPDATE_ROLE_SUCCESS = "ROLE_MANAGEMENT_UPDATE_ROLE_SUCCESS";
export const ROLE_MANAGEMENT_LOAD_ROLE = "ROLE_MANAGEMENT_LOAD_ROLE"
export const ROLE_MANAGEMENT_LOAD_ROLE_SUCCESS = "ROLE_MANAGEMENT_LOAD_ROLE_SUCCESS";
export const ROLE_MANAGEMENT_DELETE_ROLE = "ROLE_MANAGEMENT_DELETE_ROLE"
export const ROLE_MANAGEMENT_DELETE_ROLE_SUCCESS = "ROLE_MANAGEMENT_DELETE_ROLE_SUCCESS";
export const ROLE_MANAGEMENT_CREATE_ROLELIST = "ROLE_MANAGEMENT_CREATE_ROLELIST"
export const ROLE_MANAGEMENT_CREATE_ROLELIST_SUCCESS = "ROLE_MANAGEMENT_CREATE_ROLELIST_SUCCESS";
export const ROLE_MANAGEMENT_LOAD_ROLELIST = "ROLE_MANAGEMENT_LOAD_ROLELIST"
export const ROLE_MANAGEMENT_LOAD_ROLELIST_SUCCESS = "ROLE_MANAGEMENT_LOAD_ROLELIST_SUCCESS";
export const ROLE_MANAGEMENT_DELETE_ROLELIST = "ROLE_MANAGEMENT_DELETE_ROLELIST"
export const ROLE_MANAGEMENT_DELETE_ROLELIST_SUCCESS = "ROLE_MANAGEMENT_DELETE_ROLELIST_SUCCESS";
export const ROLE_MANAGEMENT_DELETE_ROLELIST_USER = "ROLE_MANAGEMENT_DELETE_ROLELIST_USER"
export const ROLE_MANAGEMENT_DELETE_ROLELIST_USER_SUCCESS = "ROLE_MANAGEMENT_DELETE_ROLELIST_USER_SUCCESS";
export const ROLE_MANAGEMENT_UPDATE_ROLELIST = "ROLE_MANAGEMENT_UPDATE_ROLELIST"
export const ROLE_MANAGEMENT_UPDATE_ROLELIST_SUCCESS = "ROLE_MANAGEMENT_UPDATE_ROLELIST_SUCCESS";
export const ROLE_MANAGEMENT_LOAD_ROLELIST_OBJECT = "ROLE_MANAGEMENT_LOAD_ROLELIST_OBJECT"
export const ROLE_MANAGEMENT_LOAD_ROLELIST_OBJECT_SUCCESS = "ROLE_MANAGEMENT_LOAD_ROLELIST_OBJECT_SUCCESS";

// /* ------------------Setting------------------- */
// STAFF MANAGEMENT 
export const SETTING_CREATE_DEPARTMENT = "SETTING_CREATE_DEPARTMENT";
export const SETTING_CREATE_DEPARTMENT_SUCCESS = "SETTING_CREATE_DEPARTMENT_SUCCESS";
export const SETTING_UPDATE_DEPARTMENT = "SETTING_UPDATE_DEPARTMENT";
export const SETTING_UPDATE_DEPARTMENT_SUCCESS = "SETTING_UPDATE_DEPARTMENT_SUCCESS";
export const SETTING_LOAD_DEPARTMENT = "SETTING_LOAD_DEPARTMENT"
export const SETTING_LOAD_DEPARTMENT_SUCCESS = "SETTING_LOAD_DEPARTMENT_SUCCESS";
export const SETTING_DELETE_DEPARTMENT = "SETTING_DELETE_DEPARTMENT"
export const SETTING_DELETE_DEPARTMENT_SUCCESS = "SETTING_DELETE_DEPARTMENT_SUCCESS";

export const SETTING_CREATE_POSITION = "SETTING_CREATE_POSITION";
export const SETTING_CREATE_POSITION_SUCCESS = "SETTING_CREATE_POSITION_SUCCESS";
export const SETTING_UPDATE_POSITION = "SETTING_UPDATE_POSITION";
export const SETTING_UPDATE_POSITION_SUCCESS = "SETTING_UPDATE_POSITION_SUCCESS";
export const SETTING_LOAD_POSITION = "SETTING_LOAD_POSITION"
export const SETTING_LOAD_POSITION_SUCCESS = "SETTING_LOAD_POSITION_SUCCESS";
export const SETTING_DELETE_POSITION = "SETTING_DELETE_POSITION"
export const SETTING_DELETE_POSITION_SUCCESS = "SETTING_DELETE_POSITION_SUCCESS";

export const SETTING_CREATE_STAFF = "SETTING_CREATE_STAFF";
export const SETTING_CREATE_STAFF_SUCCESS = "SETTING_CREATE_STAFF_SUCCESS";
export const SETTING_UPDATE_STAFF = "SETTING_UPDATE_STAFF";
export const SETTING_UPDATE_STAFF_SUCCESS = "SETTING_UPDATE_STAFF_SUCCESS";
export const SETTING_LOAD_STAFF = "SETTING_LOAD_STAFF"
export const SETTING_LOAD_STAFF_SUCCESS = "SETTING_LOAD_STAFF_SUCCESS";
export const SETTING_DELETE_STAFF = "SETTING_DELETE_STAFF"
export const SETTING_DELETE_STAFF_SUCCESS = "SETTING_DELETE_STAFF_SUCCESS";

// User MANAGEMENT 
export const SETTING_CREATE_PERMISSION = "SETTING_CREATE_PERMISSION";
export const SETTING_CREATE_PERMISSION_SUCCESS = "SETTING_CREATE_PERMISSION_SUCCESS";
export const SETTING_UPDATE_PERMISSION = "SETTING_UPDATE_PERMISSION";
export const SETTING_UPDATE_PERMISSION_SUCCESS = "SETTING_UPDATE_PERMISSION_SUCCESS";
export const SETTING_LOAD_PERMISSION = "SETTING_LOAD_PERMISSION"
export const SETTING_LOAD_PERMISSION_SUCCESS = "SETTING_LOAD_PERMISSION_SUCCESS";
export const SETTING_DELETE_PERMISSION = "SETTING_DELETE_PERMISSION"
export const SETTING_DELETE_PERMISSION_SUCCESS = "SETTING_DELETE_PERMISSION_SUCCESS";

export const SETTING_CREATE_USER = "SETTING_CREATE_USER";
export const SETTING_CREATE_USER_SUCCESS = "SETTING_CREATE_USER_SUCCESS";
export const SETTING_UPDATE_USER = "SETTING_UPDATE_USER";
export const SETTING_UPDATE_USER_SUCCESS = "SETTING_UPDATE_USER_SUCCESS";
export const SETTING_LOAD_USER = "SETTING_LOAD_USER"
export const SETTING_LOAD_USER_SUCCESS = "SETTING_LOAD_USER_SUCCESS";
export const SETTING_DELETE_USER = "SETTING_DELETE_USER"
export const SETTING_DELETE_USER_SUCCESS = "SETTING_DELETE_USER_SUCCESS";

export const SETTING_CREATE_USER_PASS = "SETTING_CREATE_USER_PASS"
export const SETTING_CREATE_USER_PASS_SUCCESS = "SETTING_CREATE_USER_PASS_SUCCESS";
export const SETTING_RESET_USER_PASS = "SETTING_RESET_USER_PASS";
export const SETTING_RESET_USER_PASS_SUCCESS = "SETTING_RESET_USER_PASS_SUCCESS";

// Company Detail 
export const COMPANY_DETAIL_LOAD_SPA = "COMPANY_DETAIL_LOAD_SPA";
export const COMPANY_DETAIL_LOAD_SPA_SUCCESS = "COMPANY_DETAIL_LOAD_SPA_SUCCESS";
export const COMPANY_DETAIL_LOAD_COMPANY_INFORMATION = "COMPANY_DETAIL_LOAD_COMPANY_INFORMATION";
export const COMPANY_DETAIL_LOAD_COMPANY_INFORMATION_SUCCESS = "COMPANY_DETAIL_LOAD_COMPANY_INFORMATION_SUCCESS";
export const COMPANY_DETAIL_UPDATE_COMPANY_PROFILE = "COMPANY_DETAIL_UPDATE_COMPANY_PROFILE";
export const COMPANY_DETAIL_UPDATE_COMPANY_PROFILE_SUCCESS = "COMPANY_DETAIL_UPDATE_COMPANY_PROFILE_SUCCESS";

// Treatment Management
export const SETTING_CREATE_TREATMENT_CATEGORY = "SETTING_CREATE_TREATMENT_CATEGORY";
export const SETTING_CREATE_TREATMENT_CATEGORY_SUCCESS = "SETTING_CREATE_TREATMENT_CATEGORY_SUCCESS";
export const SETTING_UPDATE_TREATMENT_CATEGORY = "SETTING_UPDATE_TREATMENT_CATEGORY";
export const SETTING_UPDATE_TREATMENT_CATEGORY_SUCCESS = "SETTING_UPDATE_TREATMENT_CATEGORY_SUCCESS";
export const SETTING_LOAD_TREATMENT_CATEGORY = "SETTING_LOAD_TREATMENT_CATEGORY"
export const SETTING_LOAD_TREATMENT_CATEGORY_SUCCESS = "SETTING_LOAD_TREATMENT_CATEGORY_SUCCESS";
export const SETTING_DELETE_TREATMENT_CATEGORY = "SETTING_DELETE_TREATMENT_CATEGORY"
export const SETTING_DELETE_TREATMENT_CATEGORY_SUCCESS = "SETTING_DELETE_TREATMENT_CATEGORY_SUCCESS";
export const SETTING_CREATE_TREATMENT = "SETTING_CREATE_TREATMENT";
export const SETTING_CREATE_TREATMENT_SUCCESS = "SETTING_CREATE_TREATMENT_SUCCESS";
export const SETTING_UPDATE_TREATMENT = "SETTING_UPDATE_TREATMENT";
export const SETTING_UPDATE_TREATMENT_SUCCESS = "SETTING_UPDATE_TREATMENT_SUCCESS";
export const SETTING_LOAD_TREATMENT = "SETTING_LOAD_TREATMENT"
export const SETTING_LOAD_TREATMENT_SUCCESS = "SETTING_LOAD_TREATMENT_SUCCESS";
export const SETTING_DELETE_TREATMENT = "SETTING_DELETE_TREATMENT"
export const SETTING_DELETE_TREATMENT_SUCCESS = "SETTING_DELETE_TREATMENT_SUCCESS";
export const SETTING_UPDATE_TREATMENT_STATUS = "SETTING_UPDATE_TREATMENT_STATUS";
export const SETTING_UPDATE_TREATMENT_STATUS_SUCCESS = "SETTING_UPDATE_TREATMENT_STATUS_SUCCESS";

// BED  MANAGEMENT getAllRoomBedMapping
export const SETTING_CREATE_BED_CATEGORY = "SETTING_CREATE_BED_CATEGORY";
export const SETTING_CREATE_BED_CATEGORY_SUCCESS = "SETTING_CREATE_BED_CATEGORY_SUCCESS";
export const SETTING_UPDATE_BED_CATEGORY = "SETTING_UPDATE_BED_CATEGORY";
export const SETTING_UPDATE_BED_CATEGORY_SUCCESS = "SETTING_UPDATE_BED_CATEGORY_SUCCESS";
export const SETTING_LOAD_BED_CATEGORY = "SETTING_LOAD_BED_CATEGORY"
export const SETTING_LOAD_BED_CATEGORY_SUCCESS = "SETTING_LOAD_BED_CATEGORY_SUCCESS";
export const SETTING_DELETE_BED_CATEGORY = "SETTING_DELETE_BED_CATEGORY"
export const SETTING_DELETE_BED_CATEGORY_SUCCESS = "SETTING_DELETE_BED_CATEGORY_SUCCESS";
export const SETTING_CREATE_BED = "SETTING_CREATE_BED";
export const SETTING_CREATE_BED_SUCCESS = "SETTING_CREATE_BED_SUCCESS";
export const SETTING_UPDATE_BED = "SETTING_UPDATE_BED";
export const SETTING_UPDATE_BED_SUCCESS = "SETTING_UPDATE_BED_SUCCESS";
export const SETTING_LOAD_BED = "SETTING_LOAD_BED"
export const SETTING_LOAD_BED_SUCCESS = "SETTING_LOAD_BED_SUCCESS";
export const SETTING_DELETE_BED = "SETTING_DELETE_BED"
export const SETTING_DELETE_BED_SUCCESS = "SETTING_DELETE_BED_SUCCESS";
export const SETTING_CREATE_ROOM = "SETTING_CREATE_ROOM";
export const SETTING_CREATE_ROOM_SUCCESS = "SETTING_CREATE_ROOM_SUCCESS";
export const SETTING_UPDATE_ROOM = "SETTING_UPDATE_ROOM";
export const SETTING_UPDATE_ROOM_SUCCESS = "SETTING_UPDATE_ROOM_SUCCESS";
export const SETTING_LOAD_ROOM = "SETTING_LOAD_ROOM"
export const SETTING_LOAD_ROOM_SUCCESS = "SETTING_LOAD_ROOM_SUCCESS";
export const SETTING_LOAD_ALL_BED_MAPPING = "SETTING_LOAD_ALL_BED_MAPPING"
export const SETTING_LOAD_ALL_BED_MAPPING_SUCCESS = "SETTING_LOAD_ALL_BED_MAPPING_SUCCESS";
export const SETTING_DELETE_ROOM = "SETTING_DELETE_ROOM"
export const SETTING_DELETE_ROOM_SUCCESS = "SETTING_DELETE_ROOM_SUCCESS";
export const SETTING_UPDATE_ROOM_STATUS = "SETTING_UPDATE_ROOM_STATUS";
export const SETTING_UPDATE_ROOM_STATUS_SUCCESS = "SETTING_UPDATE_ROOM_STATUS_SUCCESS";

// PROMOTION
export const SETTING_LOAD_PROMOTION_CATEGORY = "SETTING_LOAD_PROMOTION_CATEGORY";
export const SETTING_LOAD_PROMOTION_CATEGORY_SUCCESS = "SETTING_LOAD_PROMOTION_CATEGORY_SUCCESS";
export const SETTING_CREATE_PROMOTION_CATEGORY = "SETTING_CREATE_PROMOTION_CATEGORY";
export const SETTING_CREATE_PROMOTION_CATEGORY_SUCCESS = "SETTING_CREATE_PROMOTION_CATEGORY_SUCCESS";
export const SETTING_UPDATE_PROMOTION_CATEGORY = "SETTING_UPDATE_PROMOTION_CATEGORY";
export const SETTING_UPDATE_PROMOTION_CATEGORY_SUCCESS = "SETTING_UPDATE_PROMOTION_CATEGORY_SUCCESS";
export const SETTING_DELETE_PROMOTION_CATEGORY = "SETTING_DELETE_PROMOTION_CATEGORY";
export const SETTING_DELETE_PROMOTION_CATEGORY_SUCCESS = "SETTING_DELETE_PROMOTION_CATEGORY_SUCCESS";

export const SETTING_LOAD_PROMOTION = "SETTING_LOAD_PROMOTION";
export const SETTING_LOAD_PROMOTION_SUCCESS = "SETTING_LOAD_PROMOTION_SUCCESS";
export const SETTING_CREATE_PROMOTION = "SETTING_CREATE_PROMOTION";
export const SETTING_CREATE_PROMOTION_SUCCESS = "SETTING_CREATE_PROMOTION_SUCCESS";
export const SETTING_UPDATE_PROMOTION = "SETTING_UPDATE_PROMOTION";
export const SETTING_UPDATE_PROMOTION_SUCCESS = "SETTING_UPDATE_PROMOTION_SUCCESS";
export const SETTING_DELETE_PROMOTION = "SETTING_DELETE_PROMOTION";
export const SETTING_DELETE_PROMOTION_SUCCESS = "SETTING_DELETE_PROMOTION_SUCCESS";

// MEMBERSHIP MANAGEMENT
export const SETTING_LOAD_MEMBERSHIP_CATEGORY = "SETTING_LOAD_MEMBERSHIP_CATEGORY";
export const SETTING_LOAD_MEMBERSHIP_CATEGORY_SUCCESS = "SETTING_LOAD_MEMBERSHIP_CATEGORY_SUCCESS";
export const SETTING_CREATE_MEMBERSHIP_CATEGORY = "SETTING_CREATE_MEMBERSHIP_CATEGORY";
export const SETTING_CREATE_MEMBERSHIP_CATEGORY_SUCCESS = "SETTING_CREATE_MEMBERSHIP_CATEGORY_SUCCESS";
export const SETTING_UPDATE_MEMBERSHIP_CATEGORY = "SETTING_UPDATE_MEMBERSHIP_CATEGORY";
export const SETTING_UPDATE_MEMBERSHIP_CATEGORY_SUCCESS = "SETTING_UPDATE_MEMBERSHIP_CATEGORY_SUCCESS";
export const SETTING_DELETE_MEMBERSHIP_CATEGORY = "SETTING_DELETE_MEMBERSHIP_CATEGORY";
export const SETTING_DELETE_MEMBERSHIP_CATEGORY_SUCCESS = "SETTING_DELETE_MEMBERSHIP_CATEGORY_SUCCESS";

export const SETTING_LOAD_MEMBERSHIP = "SETTING_LOAD_MEMBERSHIP";
export const SETTING_LOAD_MEMBERSHIP_SUCCESS = "SETTING_LOAD_MEMBERSHIP_SUCCESS";
export const SETTING_CREATE_MEMBERSHIP = "SETTING_CREATE_MEMBERSHIP";
export const SETTING_CREATE_MEMBERSHIP_SUCCESS = "SETTING_CREATE_MEMBERSHIP_SUCCESS";
export const SETTING_UPDATE_MEMBERSHIP = "SETTING_UPDATE_MEMBERSHIP";
export const SETTING_UPDATE_MEMBERSHIP_SUCCESS = "SETTING_UPDATE_MEMBERSHIP_SUCCESS";
export const SETTING_DELETE_MEMBERSHIP = "SETTING_DELETE_MEMBERSHIP";
export const SETTING_DELETE_MEMBERSHIP_SUCCESS = "SETTING_DELETE_MEMBERSHIP_SUCCESS";
export const SETTING_LOAD_ALL_MEMBERSHIP_CUSTOMER = "SETTING_LOAD_ALL_MEMBERSHIP_CUSTOMER";
export const SETTING_LOAD_ALL_MEMBERSHIP_CUSTOMER_SUCCESS = "SETTING_LOAD_ALL_MEMBERSHIP_CUSTOMER_SUCCESS";

// PACKAGE MANAGEMENT
export const SETTING_CREATE_PACKAGE_CATEGORY = "SETTING_CREATE_PACKAGE_CATEGORY";
export const SETTING_CREATE_PACKAGE_CATEGORY_SUCCESS = "SETTING_CREATE_PACKAGE_CATEGORY_SUCCESS";
export const SETTING_UPDATE_PACKAGE_CATEGORY = "SETTING_UPDATE_PACKAGE_CATEGORY";
export const SETTING_UPDATE_PACKAGE_CATEGORY_SUCCESS = "SETTING_UPDATE_PACKAGE_CATEGORY_SUCCESS";
export const SETTING_LOAD_PACKAGE_CATEGORY = "SETTING_LOAD_PACKAGE_CATEGORY"
export const SETTING_LOAD_PACKAGE_CATEGORY_SUCCESS = "SETTING_LOAD_PACKAGE_CATEGORY_SUCCESS";
export const SETTING_DELETE_PACKAGE_CATEGORY = "SETTING_DELETE_PACKAGE_CATEGORY"
export const SETTING_DELETE_PACKAGE_CATEGORY_SUCCESS = "SETTING_DELETE_PACKAGE_CATEGORY_SUCCESS";
export const SETTING_CREATE_PACKAGE = "SETTING_CREATE_PACKAGE";
export const SETTING_CREATE_PACKAGE_SUCCESS = "SETTING_CREATE_PACKAGE_SUCCESS";
export const SETTING_UPDATE_PACKAGE = "SETTING_UPDATE_PACKAGE";
export const SETTING_UPDATE_PACKAGE_SUCCESS = "SETTING_UPDATE_PACKAGE_SUCCESS";
export const SETTING_LOAD_PACKAGE = "SETTING_LOAD_PACKAGE"
export const SETTING_LOAD_PACKAGE_SUCCESS = "SETTING_LOAD_PACKAGE_SUCCESS";
export const SETTING_DELETE_PACKAGE = "SETTING_DELETE_PACKAGE"
export const SETTING_DELETE_PACKAGE_SUCCESS = "SETTING_DELETE_PACKAGE_SUCCESS";
export const SETTING_UPDATE_PACKAGE_STATUS = "SETTING_UPDATE_PACKAGE_STATUS"
export const SETTING_UPDATE_PACKAGE_STATUS_SUCCESS = "SETTING_UPDATE_PACKAGE_STATUS_SUCCESS";

// Customer MANAGEMENT Organization
export const SETTING_CREATE_ORGANIZATION_TYPE = "SETTING_CREATE_ORGANIZATION_TYPE";
export const SETTING_CREATE_ORGANIZATION_TYPE_SUCCESS = "SETTING_CREATE_ORGANIZATION_TYPE_SUCCESS";
export const SETTING_UPDATE_ORGANIZATION_TYPE = "SETTING_UPDATE_ORGANIZATION_TYPE";
export const SETTING_UPDATE_ORGANIZATION_TYPE_SUCCESS = "SETTING_UPDATE_ORGANIZATION_TYPE_SUCCESS";
export const SETTING_LOAD_ORGANIZATION_TYPE = "SETTING_LOAD_ORGANIZATION_TYPE"
export const SETTING_LOAD_ORGANIZATION_TYPE_SUCCESS = "SETTING_LOAD_ORGANIZATION_TYPE_SUCCESS";
export const SETTING_DELETE_ORGANIZATION_TYPE = "SETTING_DELETE_ORGANIZATION_TYPE"
export const SETTING_DELETE_ORGANIZATION_TYPE_SUCCESS = "SETTING_DELETE_ORGANIZATION_TYPE_SUCCESS";
export const SETTING_CREATE_ORGANIZATION = "SETTING_CREATE_ORGANIZATION";
export const SETTING_CREATE_ORGANIZATION_SUCCESS = "SETTING_CREATE_ORGANIZATION_SUCCESS";
export const SETTING_UPDATE_ORGANIZATION = "SETTING_UPDATE_ORGANIZATION";
export const SETTING_UPDATE_ORGANIZATION_SUCCESS = "SETTING_UPDATE_ORGANIZATION_SUCCESS";
export const SETTING_LOAD_ORGANIZATION = "SETTING_LOAD_ORGANIZATION"
export const SETTING_LOAD_ORGANIZATION_SUCCESS = "SETTING_LOAD_ORGANIZATION_SUCCESS";
export const SETTING_DELETE_ORGANIZATION = "SETTING_DELETE_ORGANIZATION"
export const SETTING_DELETE_ORGANIZATION_SUCCESS = "SETTING_DELETE_ORGANIZATION_SUCCESS";
export const SETTING_CREATE_CUSTOMER = "SETTING_CREATE_CUSTOMER";
export const SETTING_CREATE_CUSTOMER_SUCCESS = "SETTING_CREATE_CUSTOMER_SUCCESS";
export const SETTING_UPDATE_CUSTOMER = "SETTING_UPDATE_CUSTOMER";
export const SETTING_UPDATE_CUSTOMER_SUCCESS = "SETTING_UPDATE_CUSTOMER_SUCCESS";
export const SETTING_LOAD_CUSTOMER = "SETTING_LOAD_CUSTOMER"
export const SETTING_LOAD_CUSTOMER_SUCCESS = "SETTING_LOAD_CUSTOMER_SUCCESS";
export const SETTING_DELETE_CUSTOMER = "SETTING_DELETE_CUSTOMER"
export const SETTING_DELETE_CUSTOMER_SUCCESS = "SETTING_DELETE_CUSTOMER_SUCCESS";

// INVENTORY MANAGEMENT
export const SETTING_LOAD_INVENTORY_CATEGORY = "SETTING_LOAD_INVENTORY_CATEGORY";
export const SETTING_LOAD_INVENTORY_CATEGORY_SUCCESS = "SETTING_LOAD_INVENTORY_CATEGORY_SUCCESS";
export const SETTING_CREATE_INVENTORY_CATEGORY = "SETTING_CREATE_INVENTORY_CATEGORY";
export const SETTING_CREATE_INVENTORY_CATEGORY_SUCCESS = "SETTING_CREATE_INVENTORY_CATEGORY_SUCCESS";
export const SETTING_UPDATE_INVENTORY_CATEGORY = "SETTING_UPDATE_INVENTORY_CATEGORY";
export const SETTING_UPDATE_INVENTORY_CATEGORY_SUCCESS = "SETTING_UPDATE_INVENTORY_CATEGORY_SUCCESS";
export const SETTING_DELETE_INVENTORY_CATEGORY = "SETTING_DELETE_INVENTORY_CATEGORY";
export const SETTING_DELETE_INVENTORY_CATEGORY_SUCCESS = "SETTING_DELETE_INVENTORY_CATEGORY_SUCCESS";

export const SETTING_LOAD_INVENTORY = "SETTING_LOAD_INVENTORY";
export const SETTING_LOAD_INVENTORY_SUCCESS = "SETTING_LOAD_INVENTORY_SUCCESS";
export const SETTING_CREATE_INVENTORY = "SETTING_CREATE_INVENTORY";
export const SETTING_CREATE_INVENTORY_SUCCESS = "SETTING_CREATE_INVENTORY_SUCCESS";
export const SETTING_UPDATE_INVENTORY = "SETTING_UPDATE_INVENTORY";
export const SETTING_UPDATE_INVENTORY_SUCCESS = "SETTING_UPDATE_INVENTORY_SUCCESS";
export const SETTING_DELETE_INVENTORY = "SETTING_DELETE_INVENTORY";
export const SETTING_DELETE_INVENTORY_SUCCESS = "SETTING_DELETE_INVENTORY_SUCCESS";

// COUPON MANAGEMENT
export const SETTING_LOAD_COUPON_CATEGORY = "SETTING_LOAD_COUPON_CATEGORY";
export const SETTING_LOAD_COUPON_CATEGORY_SUCCESS = "SETTING_LOAD_COUPON_CATEGORY_SUCCESS";
export const SETTING_CREATE_COUPON_CATEGORY = "SETTING_CREATE_COUPON_CATEGORY";
export const SETTING_CREATE_COUPON_CATEGORY_SUCCESS = "SETTING_CREATE_COUPON_CATEGORY_SUCCESS";
export const SETTING_UPDATE_COUPON_CATEGORY = "SETTING_UPDATE_COUPON_CATEGORY";
export const SETTING_UPDATE_COUPON_CATEGORY_SUCCESS = "SETTING_UPDATE_COUPON_CATEGORY_SUCCESS";
export const SETTING_DELETE_COUPON_CATEGORY = "SETTING_DELETE_COUPON_CATEGORY";
export const SETTING_DELETE_COUPON_CATEGORY_SUCCESS = "SETTING_DELETE_COUPON_CATEGORY_SUCCESS";

export const SETTING_LOAD_COUPON = "SETTING_LOAD_COUPON";
export const SETTING_LOAD_COUPON_SUCCESS = "SETTING_LOAD_COUPON_SUCCESS";
export const SETTING_CREATE_COUPON = "SETTING_CREATE_COUPON";
export const SETTING_CREATE_COUPON_SUCCESS = "SETTING_CREATE_COUPON_SUCCESS";
export const SETTING_UPDATE_COUPON = "SETTING_UPDATE_COUPON";
export const SETTING_UPDATE_COUPON_SUCCESS = "SETTING_UPDATE_COUPON_SUCCESS";
export const SETTING_DELETE_COUPON = "SETTING_DELETE_COUPON";
export const SETTING_DELETE_COUPON_SUCCESS = "SETTING_DELETE_COUPON_SUCCESS";

// SERVICE FEE MANAGEMENT SERVICE_FEE
export const SETTING_CREATE_SERVICE_FEE = "SETTING_CREATE_SERVICE_FEE";
export const SETTING_CREATE_SERVICE_FEE_SUCCESS = "SETTING_CREATE_SERVICE_FEE_SUCCESS";
export const SETTING_UPDATE_SERVICE_FEE = "SETTING_UPDATE_SERVICE_FEE";
export const SETTING_UPDATE_SERVICE_FEE_SUCCESS = "SETTING_UPDATE_SERVICE_FEE_SUCCESS";
export const SETTING_LOAD_SERVICE_FEE = "SETTING_LOAD_SERVICE_FEE"
export const SETTING_LOAD_SERVICE_FEE_SUCCESS = "SETTING_LOAD_SERVICE_FEE_SUCCESS";
export const SETTING_DELETE_SERVICE_FEE = "SETTING_DELETE_SERVICE_FEE"
export const SETTING_DELETE_SERVICE_FEE_SUCCESS = "SETTING_DELETE_SERVICE_FEE_SUCCESS";

// /* ------------------ Queue ------------------- */
// QUEUE MANAGEMENT
export const QUEUE_MANAGEMENT_CREATE_QUEUE = "QUEUE_MANAGEMENT_CREATE_QUEUE";
export const QUEUE_MANAGEMENT_CREATE_QUEUE_SUCCESS = "QUEUE_MANAGEMENT_CREATE_QUEUE_SUCCESS";
export const QUEUE_MANAGEMENT_UPDATE_QUEUE = "QUEUE_MANAGEMENT_UPDATE_QUEUE";
export const QUEUE_MANAGEMENT_UPDATE_QUEUE_SUCCESS = "QUEUE_MANAGEMENT_UPDATE_QUEUE_SUCCESS";
export const QUEUE_MANAGEMENT_LOAD_QUEUE = "QUEUE_MANAGEMENT_LOAD_QUEUE"
export const QUEUE_MANAGEMENT_LOAD_QUEUE_SUCCESS = "QUEUE_MANAGEMENT_LOAD_QUEUE_SUCCESS";
export const QUEUE_MANAGEMENT_LOAD_QUEUE_BY_DATE = "QUEUE_MANAGEMENT_LOAD_QUEUE_BY_DATE"
export const QUEUE_MANAGEMENT_LOAD_QUEUE_BY_DATE_SUCCESS = "QUEUE_MANAGEMENT_LOAD_QUEUE_BY_DATE_SUCCESS";
export const QUEUE_MANAGEMENT_DELETE_QUEUE = "QUEUE_MANAGEMENT_DELETE_QUEUE"
export const QUEUE_MANAGEMENT_DELETE_QUEUE_SUCCESS = "QUEUE_MANAGEMENT_DELETE_QUEUE_SUCCESS";

// /* ------------------ Housekeeping ------------------- */
// HOUSEKEEPING MANAGEMENT
export const HOUSEKEEPING_MANAGEMENT_CREATE_HOUSEKEEPING = "HOUSEKEEPING_MANAGEMENT_CREATE_HOUSEKEEPING";
export const HOUSEKEEPING_MANAGEMENT_CREATE_HOUSEKEEPING_SUCCESS = "HOUSEKEEPING_MANAGEMENT_CREATE_HOUSEKEEPING_SUCCESS";
export const HOUSEKEEPING_MANAGEMENT_UPDATE_HOUSEKEEPING = "HOUSEKEEPING_MANAGEMENT_UPDATE_HOUSEKEEPING";
export const HOUSEKEEPING_MANAGEMENT_UPDATE_HOUSEKEEPING_SUCCESS = "HOUSEKEEPING_MANAGEMENT_UPDATE_HOUSEKEEPING_SUCCESS";
export const HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING = "HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING"
export const HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_SUCCESS = "HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_SUCCESS";
export const HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_BY_DATE = "HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_BY_DATE"
export const HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_BY_DATE_SUCCESS = "HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_BY_DATE_SUCCESS";
export const HOUSEKEEPING_MANAGEMENT_DELETE_HOUSEKEEPING = "HOUSEKEEPING_MANAGEMENT_DELETE_HOUSEKEEPING"
export const HOUSEKEEPING_MANAGEMENT_DELETE_HOUSEKEEPING_SUCCESS = "HOUSEKEEPING_MANAGEMENT_DELETE_HOUSEKEEPING_SUCCESS";

// /* ------------------ Booking ------------------- */
//  Booking 
export const BOOKING_LOAD_BOOKING_LIST = "BOOKING_LOAD_BOOKING_LIST";
export const BOOKING_LOAD_BOOKING_LIST_SUCCESS = "BOOKING_LOAD_BOOKING_LIST_SUCCESS";
export const BOOKING_LOAD_ALL_PAYMENT_BOOKING_LIST_SUCCESS = "BOOKING_LOAD_ALL_PAYMENT_BOOKING_LIST_SUCCESS";
export const BOOKING_LOAD_BOOKING_TOPBAR = "BOOKING_LOAD_BOOKING_TOPBAR";
export const BOOKING_LOAD_BOOKING_TOPBAR_SUCCESS = "BOOKING_LOAD_BOOKING_TOPBAR_SUCCESS";


// /* ------------------ Petty Cash ------------------- */
// //  Petty Cash Management
export const PETTY_CASH_LOAD_PETTY_CASH_TOPBAR = "PETTY_CASH_LOAD_PETTY_CASH_TOPBAR";
export const PETTY_CASH_LOAD_PETTY_CASH_TOPBAR_SUCCESS = "PETTY_CASH_LOAD_PETTY_CASH_TOPBAR_SUCCESS";

export * from './menu/actions';
export * from './settings/actions';
export * from './auth/actions';
export * from './todo/actions';
export * from './chat/actions';
export * from './surveyList/actions';
export * from './surveyDetail/actions';
// export * from './user/actions';
// export * from './company/actions';
export * from './settingManagement/staffManagement/actions';
export * from './settingManagement/userManagement/actions';
export * from './settingManagement/companyDetail/actions';
export * from './settingManagement/treatmentManagement/actions';
export * from './settingManagement/bedManagement/actions';
export * from './settingManagement/promotionManagement/actions';
export * from './settingManagement/membershipManagement/actions';
export * from './settingManagement/packageManagement/actions';
export * from './settingManagement/customerManagement/actions';
export * from './settingManagement/serviceFeeManagement/actions';
export * from './settingManagement/inventoryManagement/actions';
export * from './settingManagement/couponManagement/actions';
// export * from './promotion/actions';
export * from './bookingManagement/actions';
export * from './queueManagement/actions';
export * from './housekeepingManagement/actions';
export * from './pettyCashManagement/actions';
